<div class="fixed inset-0 z-50 flex items-center justify-center">

  <!-- Backdrop -->
  <div
    class="absolute inset-0 bg-black/50 transition-opacity duration-200"
    [class.opacity-100]="isVisible()"
    [class.opacity-0]="!isVisible()"
    [class.pointer-events-none]="!isVisible()"
    (click)="onBackdropClick()"
  ></div>

  <!-- Modal -->
  <div
    class="relative z-10 max-w-[1000px] rounded-lg bg-white shadow-xl py-2 px-4 transform transition-all duration-200"
    [class.opacity-100]="isVisible()"
    [class.opacity-0]="!isVisible()"
    [class.scale-100]="isVisible()"
    [class.scale-95]="!isVisible()"
    [class.pointer-events-none]="!isVisible()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between px-4 py-3">
      <h2 class="text-xl font-semibold text-gray-700">
        {{ title }}
      </h2>
      <button
        class="text-gray-500 hover:text-gray-700 cursor-pointer"
        (click)="close()"
      >
        <lucide-icon [name]="X" [size]="26"></lucide-icon>
      </button>
    </div>

    <div class="p-4">
      <ng-template #content></ng-template>
    </div>
  </div>
</div>
